import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import GradeForm from '../components/forms/GradeForm';
import '../styles/EmployeeMaster.css';
import GradeTable from '../components/GradeTable';

const GradeModel = () => {
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/grade/add';

     const handleAddClick = () => {
          navigate('/grade/add');
     };

     const handleCloseModal = () => {
          navigate('/grade');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Grade Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Grade
                    </button>
               </div>

               <GradeTable />

               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    size="md"
                    centered
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Add New Grade</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <GradeForm />
                    </Modal.Body>
                    <Modal.Footer>
                         <Button variant="secondary" onClick={handleCloseModal}>
                              Close
                         </Button>
                         <Button variant="primary">
                              Save
                         </Button>
                    </Modal.Footer>
               </Modal>
          </div>
     );
};

export default GradeModel;
